
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 531 331"}},[_c('path',{attrs:{"fill":"#062521","fill-rule":"evenodd","d":"M485.314 119.34C336.256 290.855 340.522 344.677 198.19 327.2c-142.334-17.476-92.666-89.923-174.67-251.47-82.002-161.549 72.524-15.58 214.858 1.897C380.71 95.103 634.372-52.175 485.314 119.34z"}})])
      }
    
      }
    